import React, { createContext, useState, useContext, useEffect } from "react";
import publicWebsiteStore from "../Stores/PublicWebsiteStore";
import PublicWebsiteConstants from "../Constants/PublicWebsiteConstants";
import PublicWebsiteActions from "../Actions/PublicWebsiteActions";
import { useGlobalSpinnerActionsContext } from "./GlobalSpinnerContext";

const EquipGrpPublicInfoContext = createContext();
const EquipGrpPublicInfoActionsContext = createContext();

export const useEquipGrpPublicInfoContext = () =>
  useContext(EquipGrpPublicInfoContext);
export const useEquipGrpPublicInfoActionsContext = () =>
  useContext(EquipGrpPublicInfoActionsContext);

export const EquipGrpPublicInfoProvider = ({ children }) => {
  const [equipGroupPublicWebConf, setEquipGroupPublicWebConf] = useState("");
  const setGlobalSpinner = useGlobalSpinnerActionsContext();

  const getEquipmentGroupPublicInfo = (anlageid) => {
    setGlobalSpinner(true);
    PublicWebsiteActions.GetEqupGroupConfiguration(anlageid);
  };

  useEffect(() => {
    function getEquipGrpConfigSuccess() {
      const res = publicWebsiteStore.getEquipGrpConfResult();
      if (res) {
        setEquipGroupPublicWebConf(res);
      }
    }

    function getEquipGrpConfigFailure() {
      const res = publicWebsiteStore.getEquipGrpConfResult();
      setGlobalSpinner(false);
    }
    publicWebsiteStore.addChangeListener(
      PublicWebsiteConstants.GET_EQUIP_GRP_CONF_SUCCESS,
      getEquipGrpConfigSuccess
    );

    publicWebsiteStore.addChangeListener(
      PublicWebsiteConstants.GET_EQUIP_GRP_CONF_FAILURE,
      getEquipGrpConfigFailure
    );
    return () => {
      publicWebsiteStore.removeChangeListener(
        PublicWebsiteConstants.GET_EQUIP_GRP_CONF_SUCCESS,
        getEquipGrpConfigSuccess
      );

      publicWebsiteStore.removeChangeListener(
        PublicWebsiteConstants.GET_EQUIP_GRP_CONF_FAILURE,
        getEquipGrpConfigFailure
      );
    };
  }, []);
  return (
    <EquipGrpPublicInfoContext.Provider value={equipGroupPublicWebConf}>
      <EquipGrpPublicInfoActionsContext.Provider
        value={getEquipmentGroupPublicInfo}
      >
        {children}
      </EquipGrpPublicInfoActionsContext.Provider>
    </EquipGrpPublicInfoContext.Provider>
  );
};
